import axios from "axios";

import { API_BASE_URL, deleteRequest, getBlobRequest, getRequest, patchRequest, postRequest } from "../../api";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

const baseUrl = (moduleId, contentId) =>
    `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/questions`;

const toQueryString = (params = {}) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            searchParams.set(key, value);
        }
    });
    const query = searchParams.toString();
    return query ? `?${query}` : "";
};

export const fetchContentQuestionsApi = (moduleId, contentId, filters = {}) =>
    getRequest({
        url: `${baseUrl(moduleId, contentId)}${toQueryString(filters)}`,
        token: getToken(),
        uid: getUid(),
    });

export const createContentQuestionApi = (moduleId, contentId, payload) =>
    postRequest({
        url: baseUrl(moduleId, contentId),
        data: payload,
        token: getToken(),
        uid: getUid(),
    });

export const createContentAnswerApi = (moduleId, contentId, questionId, payload) =>
    postRequest({
        url: `${baseUrl(moduleId, contentId)}/${questionId}/answers`,
        data: payload,
        token: getToken(),
        uid: getUid(),
    });

export const resolveContentQuestionApi = (moduleId, contentId, questionId) =>
    patchRequest({
        url: `${baseUrl(moduleId, contentId)}/${questionId}/resolve`,
        data: {},
        token: getToken(),
        uid: getUid(),
    });

export const setContentBestAnswerApi = (moduleId, contentId, questionId, answerId) =>
    patchRequest({
        url: `${baseUrl(moduleId, contentId)}/${questionId}/best-answer/${answerId}`,
        data: {},
        token: getToken(),
        uid: getUid(),
    });

export const toggleQuestionReactionApi = (moduleId, contentId, questionId, reactionType) =>
    postRequest({
        url: `${baseUrl(moduleId, contentId)}/${questionId}/reactions/toggle`,
        data: { reactionType },
        token: getToken(),
        uid: getUid(),
    });

export const toggleAnswerReactionApi = (moduleId, contentId, questionId, answerId, reactionType) =>
    postRequest({
        url: `${baseUrl(moduleId, contentId)}/${questionId}/answers/${answerId}/reactions/toggle`,
        data: { reactionType },
        token: getToken(),
        uid: getUid(),
    });

const uploadAttachment = ({ url, file, onUploadProgress }) => {
    const formData = new FormData();
    formData.append("file", file);
    return axios.post(url, formData, {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${getToken()}`,
            uid: getUid(),
            "X-Tenant-Id": sessionStorage.getItem("selectedCompanyId"),
        },
        onUploadProgress,
    });
};

export const uploadQuestionAttachmentApi = (moduleId, contentId, questionId, file, onUploadProgress) =>
    uploadAttachment({
        url: `${baseUrl(moduleId, contentId)}/${questionId}/attachments`,
        file,
        onUploadProgress,
    });

export const uploadAnswerAttachmentApi = (moduleId, contentId, questionId, answerId, file, onUploadProgress) =>
    uploadAttachment({
        url: `${baseUrl(moduleId, contentId)}/${questionId}/answers/${answerId}/attachments`,
        file,
        onUploadProgress,
    });

export const downloadQuestionAttachmentApi = (moduleId, contentId, attachmentId) =>
    getBlobRequest({
        url: `${baseUrl(moduleId, contentId)}/attachments/${attachmentId}/download`,
        token: getToken(),
        extraHeaders: {
            uid: getUid(),
            "X-Tenant-Id": sessionStorage.getItem("selectedCompanyId"),
        },
    });

export const deleteQuestionAttachmentApi = (moduleId, contentId, attachmentId) =>
    deleteRequest({
        url: `${baseUrl(moduleId, contentId)}/attachments/${attachmentId}`,
        token: getToken(),
        uid: getUid(),
    });
